import { useEffect, useMemo, useRef } from 'react';
import { debounce } from 'lodash';

// Returns a debounced version of callback that is stable across renders.
// The latest callback is always invoked, so it never sees stale state.
// Any pending call is flushed on unmount so taps are not lost.
export const useDebouncedCallback = <T extends (...args: any[]) => void>(
  callback: T,
  delay: number
) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const debounced = useMemo(
    () =>
      debounce((...args: Parameters<T>) => callbackRef.current(...args), delay),
    [delay]
  );

  useEffect(() => () => debounced.flush(), [debounced]);

  return debounced;
};
